import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Search, Calendar, User } from 'lucide-react';
import { motion } from 'framer-motion';

interface NavItem {
  icon: React.ReactNode;
  label: string;
  path: string;
  badge?: number;
}

const BottomNavigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const navItems: NavItem[] = [
    {
      icon: <Home className="w-6 h-6" />,
      label: 'Home',
      path: '/dashboard'
    },
    {
      icon: <Search className="w-6 h-6" />,
      label: 'Discover',
      path: '/restaurants'
    },
    {
      icon: <Calendar className="w-6 h-6" />,
      label: 'Reservations',
      path: '/reservations'
    },
    {
      icon: <User className="w-6 h-6" />,
      label: 'Profile',
      path: '/profile'
    }
  ];
  
  const isActiveRoute = (path: string) => {
    if (path === '/dashboard') {
      return location.pathname === '/' || location.pathname === '/dashboard';
    }
    return location.pathname.startsWith(path);
  };
  
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-bottom">
      <div className="flex items-center justify-around py-2">
        {navItems.map((item) => {
          const isActive = isActiveRoute(item.path);
          
          return (
            <motion.button
              key={item.path}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate(item.path)}
              className={`
                flex flex-col items-center justify-center p-2 min-w-0 flex-1 relative
                ${isActive ? 'text-primary-600' : 'text-gray-500'}
                transition-colors duration-200
              `}
            >
              <div className="relative mb-1">
                {item.icon}
                {item.badge && item.badge > 0 && (
                  <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                    {item.badge > 9 ? '9+' : item.badge}
                  </div>
                )}
              </div>
              
              <span className={`
                text-xs font-medium truncate w-full text-center
                ${isActive ? 'text-primary-600' : 'text-gray-500'}
              `}>
                {item.label}
              </span>
              
              {isActive && (
                <motion.div
                  layoutId="activeTab"
                  className="absolute -top-0.5 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-primary-600 rounded-full"
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.2 }}
                />
              )}
            </motion.button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;